module.exports = __webpack_public_path__ + "img/manage3.9edfd1d4.png";